import Home from './pages/Home';
import Features from './pages/Features';
import Community from './pages/Community';
import Rankings from './pages/Rankings';
import Support from './pages/Support';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import MediaGallery from './pages/MediaGallery';
import Layout from './Layout.jsx';


export const PAGES = {
    "Home": Home,
    "Features": Features,
    "Community": Community,
    "Rankings": Rankings,
    "Support": Support,
    "Login": Login,
    "Register": Register,
    "Dashboard": Dashboard,
    "MediaGallery": MediaGallery,
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: Layout,
};